import Button from '@atlaskit/button';
import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

/* Until we support themes in the app, we can't use the atlaskit Button
because it doesn't provide the desired isSelected colors. Since we don't support
themes, it uses the fallback color which is dark gray. */
export const SelectableButton = styled(Button)<{
  $isActive?: boolean;
  $isSelected?: boolean;
}>`
  &&,
  &&:hover {
    background: ${({ $isActive, $isSelected }) =>
      ($isActive || $isSelected) &&
      token('color.background.accent.blue.subtlest', '#E9F2FF')};

    span {
      color: ${({ $isActive, $isSelected }) =>
        ($isActive || $isSelected) && token('color.icon.selected', '#0C66E4')};
    }
  }
`;
